import type { ReactNode } from "react";

export const isRenderableNode = (node: ReactNode): boolean =>
  node !== null && node !== undefined && typeof node !== "boolean" && node !== "";

export const getNonEmptyString = (value: unknown): string | undefined =>
  typeof value === "string" && value.length > 0 ? value : undefined;

export const isNonEmptyString = (value: unknown): boolean =>
  typeof value === "string" && value.trim().length > 0;
